<template>
  <div class="d-flex colomn">
    <div>
      <div class="d-flex row">
        <p>Source Assortiment</p>
        <input
          id="Json"
          type="text"
          @change="sourceAssInput()"
          v-model="SelectedSourceAssortiment"
        />
      </div>
      <div class="d-flex row mx-5">
        <p>Source Collection</p>
        <input
          id="Product"
          type="text"
          @change="sourceColInput()"
          v-model="SelectedSourceCollection"
        />
      </div>
    </div>
    <div>
      <div>
        <div class="d-flex row">
          <p>Destination Assortiment</p>
          <input id="Json" type="text" v-model="SelectedDestAssortiment" />
        </div>
        <div class="d-flex row mx-5">
          <p>Destination Collection</p>
          <input id="Product" type="text" v-model="SelectedDestCollection" />
        </div>
      </div>
    </div>
    <button class="mx-5" @mouseup="getProductData()">Get</button>
  </div>
  <div class="d-flex column mt-3">
    <div class="me-5">
      <p>copy from {{ sourceLang }} to {{ destinationLang }}</p>
      <pre>{{ productText.nl }}</pre>
    </div>
  </div>
</template>

<script>
import json from "@/scripts/json.js";

export default {
  data() {
    return {
      SelectedSourceAssortiment: "selecteer bron assortiment",
      SelectedSourceCollection: "selecteer bron collectie",
      SelectedSourceProduct: "Safe Tex R11",
      SelectedDestAssortiment: "selecteer doel assortiment",
      SelectedDestCollection: "selecteer doel collectie",
      SelectedDestProduct: "rev-expo",
      destinationLang: "nl-NL",
      sourceLang: "en-EN",
      productText: {
        nl: "",
        en: "",
      },
      copy: [
        // "afbeelding",
        // "afbeeldingMeerdere",
        // "code",
        "kleur",
        "kleurFilter",
        // "rolBreedte",
        // "rolBreedteEenheid",
        // "hoogte",
        // "hoogteEenheid",
        // "brandKlasse",
        // "lengte",
        // "lengteEenheid",
        // "slijtLaag",
        // "slijtLaagEenheid",
        // "breedte",
        // "breedteEenheid",
        // "dikte",
        // "dikteEenheid"
      ],
    };
  },
  computed: {},
  methods: {
    getProductData() {
      this.productText.nl = json.copyProductData(
        this.SelectedSourceAssortiment,
        this.SelectedSourceCollection,
        this.SelectedDestAssortiment,
        this.SelectedDestCollection,
        this.sourceLang,
        this.destinationLang,
        this.copy
      );
    },
    sourceAssInput() {
      this.SelectedDestAssortiment = this.SelectedSourceAssortiment;
    },
    sourceColInput() {
      this.SelectedDestCollection = this.SelectedSourceCollection;
    },
    // end methods
  },
};
</script>
<style scoped>
pre {
  -webkit-user-select: all; /* Safari */
  -ms-user-select: all; /* IE 10 and IE 11 */
  user-select: all; /* Standard syntax */
}
</style>
